import {ChangeDetectorRef, Component, forwardRef, Input, OnChanges, SimpleChange, SimpleChanges} from '@angular/core';


@Component({
	selector: 'form-engine',
	templateUrl: 'form.html',
	host: {'class': 'form-engine'}
})
export class UIFormEngineComponent {
	@Input() metadata: UIFormEngineComponentMetadata;
	@Input() data;
	@Input() presentationMode = false;
	@Input() depth = 1;

	public tableHeaders = [];

	constructor() {
	}

	/* should be done outside, DATA and METADATA should match ngOnChanges(changes) {
		// fix missing reference between metadata and data, e.g. metadata has inputs but data is eempty
		if (changes['metadata'].currentValue) {
			for (let content of this.metadata.content) {
				if (this.data && !this.data[content.id]) {
					this.data[content.id] = content.type == 'container' ? {} : null;
				}
			}

			// add fixed-rows to table layouts
			if (this.metadata.layout && this.metadata.layout.type == 'table') {
				this.tableHeaders = [];
				let first = true;
				for (let content of this.metadata.content) {
					if (first) {
						first = false;
						for (let row of content.content) {
							if (row.layout && row.layout.type == 'fixed-row') {
								this.tableHeaders.push('');
							} else {
								this.tableHeaders.push(row.label);
							}
						}
					}
				}
			}
			console.log('this.data', changes['data'], this.data);
			// we have changed the data and we need to recheck before the view uses them
			this.cds.detectChanges();
		}
	}*/
}

export class UIFormEngineComponentMetadata {
	public id;
	public idFunction = (id) => {
		return id;
	};
	public label?:string;
	public hint?;
	public status? = 'active';
	public type? = 'container'; // or type of input
	public layout? = new UIFormEngineComponentLayout;
	public options?: UIFormEngineComponentMetadataOptions = new UIFormEngineComponentMetadataOptions();
	public content?: UIFormEngineComponentMetadata[] = [];
}

export class UIFormEngineComponentMetadataOptions {
	public choices? = {};
	public noEmptyChoice? = false;
	public emptyChoiceText = '(No Selection)';
	public url? = '';
	public decimals? = 0;
	public multiple? = false;
	public placeholder? = '';
	public reversed? = false;
	public exactMatch? = false;
	public na? = false;
	public colors? = false;
}

export class UIFormEngineComponentLayout {
	public type? = {};
	public inputWidth? = 3;
	public labelWidth? = 9;
	public group?;
}

